import { VpMaskMethods } from '@ps/bridge/qc/vp/mask'
const VpCategories = {
  mask: 'マスクコンポーネント',
}
export default {
  maskAction: {
    [VpMaskMethods.vpEnableMaskComponent]: {
      label: 'マスクコンポーネントの有効化/無効化',
      category: VpCategories.mask,
      paramFormConfig: {
        isEnable: {
          title: '有効化/無効化',
          field: {
            options: [
              {
                label: '有効化',
              },
              {
                label: '無効化',
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpEnableMaskGroupComponent]: {
      label: 'マスクグループの有効化/無効化',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: '有効化/無効化',
          component: 'select',
          field: {
            options: [
              {
                label: '有効化',
                value: true,
              },
              {
                label: '無効化',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpShowMaskGroup]: {
      label: 'マスクグループの表示/非表示',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
        isShow: {
          title: '表示/非表示',
          component: 'select',
          field: {
            options: [
              {
                label: '表示',
                value: true,
              },
              {
                label: '非表示',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpShowMaskSubGroup]: {
      label: 'マスクされたグループの表示/非表示',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
        isShow: {
          title: '表示/非表示',
          component: 'select',
          field: {
            options: [
              {
                label: '表示',
                value: true,
              },
              {
                label: '非表示',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpEnableMaskShape]: {
      label: 'マスク効果の有効化/無効化',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: '応答オブジェクト',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: '有効化/無効化',
          component: 'select',
          field: {
            options: [
              {
                label: '有効化',
                value: true,
              },
              {
                label: '無効化',
                value: false,
              },
            ],
          },
        },
      },
    },
  },
}
